import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Post, Query, Req } from '@nestjs/common';
import { ApiHeader, ApiQuery, ApiTags } from '@nestjs/swagger';
import { AllWelfaretypeResponseModel, WelfaretypeResponseModel } from './dto/welfaretype-response-module';
import { WelfaretypeDTO, WelfaretypeStatusDTO } from './dto/welfaretype.dto';
import { WelfaretypeService } from './welfaretype.service';
@ApiTags('welfaretype')
@Controller('welfaretype')
export class WelfaretypeController {

    constructor (
        private WelfaretypeService:WelfaretypeService
    ) {}
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createWelafaretype')
    @ApiQuery({name:'apiVersion'})
    async createWelafaretype(@Query() queryParams, @Body() WelfaretypeDTO:WelfaretypeDTO, @Req() request: Request): Promise<WelfaretypeResponseModel> {
        try {
            return await this.WelfaretypeService.createWelafaretype(queryParams, WelfaretypeDTO, request);
        } catch (error) {
            return errorHandler(WelfaretypeResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getWelfaretype')
    @ApiQuery({name:'apiVersion'})
    async getWelfaretype(@Query() queryParams, @Req() request:Request): Promise<AllWelfaretypeResponseModel> {
        try {
            return await this.WelfaretypeService.getWelfaretype(queryParams, request);
        } catch (error) {
            return errorHandler(AllWelfaretypeResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateWelfaretype')
    @ApiQuery({name:'apiVersion'})
    async updateWelfaretype(@Query() queryParams, @Body() WelfaretypeDTO:WelfaretypeDTO, @Req() request: Request): Promise<WelfaretypeResponseModel> {
        try {
            return await this.WelfaretypeService.updateWelfaretype(queryParams, WelfaretypeDTO, request);
        } catch (error) {
            return errorHandler(WelfaretypeResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updatewelfaretypeStatus')
    @ApiQuery({name:'apiVersion'})
    async updatewelfaretypeStatus(@Query() queryParams, @Body() WelfaretypeStatusDTO:WelfaretypeStatusDTO, @Req() request: Request): Promise<WelfaretypeResponseModel> {
        try {
            return await this.WelfaretypeService.updatewelfaretypeStatus(queryParams, WelfaretypeStatusDTO, request);
        } catch (error) {
            return errorHandler(WelfaretypeResponseModel, error);
        }
    }


}
